import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiControlVideoDeleteComponent } from './ui-control-video-delete.component';

@NgModule({
  declarations: [UiControlVideoDeleteComponent],
  exports: [UiControlVideoDeleteComponent],
  imports: [CommonModule],
})
export class UiControlVideoDeleteModule {}
